import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Tv2 = createReactComponent("Tv2", ["svg", defaultAttributes, [["path", {
  d: "M7 21h10",
  key: "1sd173"
}], ["rect", {
  x: "2",
  y: "3",
  width: "20",
  height: "14",
  rx: "2",
  key: "9rbjce"
}]]]);
export default Tv2;